<template>
  <dependants-coverage-table :dependants="dependants" :loading="loading">
    <template #action="{ record }">
      <template
        v-if="
          !record.isStaged &&
          !ticketLoading &&
          ![TICKET.STATES.CANCELED, TICKET.STATES.EXECUTED].includes(
            ticket.state?.id
          )
        "
      >
        <a-tooltip placement="topLeft" title="Eliminar">
          <a-popconfirm
            title="¿Estás seguro de eliminar esta carga?"
            ok-text="Sí"
            cancel-text="No"
            @confirm="
              () =>
                deleteDependant(
                  record.employeeDependant?.ticketId,
                  record.employeeDependant?.id
                )
            "
          >
            <a-button type="link">
              <delete-outlined class="red-icon" />
            </a-button>
          </a-popconfirm>
        </a-tooltip>
      </template>
    </template>
  </dependants-coverage-table>
</template>

<script setup>
import {
  GET_TICKET_DEPENDANTS,
  DELETE_TICKET_DEPENDANT,
  GET_TICKET,
  GET_TICKET_AVAILABLE_COVERAGES
} from '@/store/types';
import TICKET from '@/constants/ticket';
import { computed } from 'vue';
import { useStore } from 'vuex';
import { DeleteOutlined } from '@ant-design/icons-vue';
import DependantsCoverageTable from '@/new-components/ticket/dependants-coverage-table.vue';
import notification from '@/utils/notifications';
import { groupTicketDependants } from '@/utils/incorporationDetailGroups';
const store = useStore();

const ticket = computed(() => store.getters[GET_TICKET].data);
const ticketLoading = computed(() => store.getters[GET_TICKET].loading);
const rawDependants = computed(() => store.getters[GET_TICKET_DEPENDANTS].data);
const loading = computed(() => store.getters[GET_TICKET_DEPENDANTS].loading);
const availableCoverages = computed(
  () => store.getters[GET_TICKET_AVAILABLE_COVERAGES] || []
);

const dependants = computed(() =>
  groupTicketDependants(rawDependants.value, availableCoverages.value)
);

const deleteDependant = async (ticketId, employeeDependantId) => {
  try {
    await store.dispatch(DELETE_TICKET_DEPENDANT, {
      ticketId,
      employeeDependantId
    });
  } catch (error) {
    console.error('Error deleting dependant', error);
    console.error('Params', ticketId, employeeDependantId);
    notification(
      'error',
      'Error',
      'No se pudo eliminar la carga. Intente de nuevo.'
    );
  }
};
</script>
